import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isNil from "lodash/isNil";
import { Stack } from "PFComponents/containers/flex/stack";
import { Radios } from "PFComponents/radios/radios";
import { useBooleanToString } from "PFCore/hooks/use_boolean_to_string";

import { letFilterRestore } from "../../use_filtered_collection";
import { ExpandedFilterParams } from "./components/expanded_filter_wrapper";
import { FilterHeader } from "./components/filter_header";

export const RadioButtonsItem = ({ filter, onChange, disabled, options }: ExpandedFilterParams) => {
  const filterValue = (isArray(filter.value) ? filter.value[0] : filter.value) as number;
  const booleanToString = useBooleanToString();
  const canRestore = letFilterRestore(filter);
  const canClear = !isNil(filterValue) && !filter.required;

  return (
    <Stack gap="spacingMd">
      <FilterHeader
        filter={filter}
        disabled={disabled}
        canClear={canClear}
        canRestore={canRestore}
        onChange={onChange}
      />
      {options.length > 0 && (
        <Radios
          items={options.map((option) => ({
            id: option.id,
            label: isBoolean(option.value)
              ? booleanToString(option.value)
              : option.displayElement || option.value
          }))}
          name={filter.name!}
          value={filterValue}
          onChange={onChange}
          disabled={disabled}
        />
      )}
    </Stack>
  );
};
